import { ChevronDownIcon } from '@/icons';
import { Select, type SelectProps } from 'antd';

type Props = SelectProps & {
  /** Width of the closed select, in px. */
  width?: number;
};

/** A toolbar filter: large, clearable, with the white arrow every filter uses. */
const FilterSelect = ({ width = 130, style, ...props }: Props) => (
  <Select
    allowClear
    size="large"
    placement="bottomRight"
    style={{ flexShrink: 0, width, ...style }}
    suffixIcon={<ChevronDownIcon className="text-white" size={24} />}
    {...props}
  />
);

export default FilterSelect;
